import { Link } from 'react-router-dom'
import PageHero from '../components/PageHero'
import PageSeo from '../components/PageSeo'
import SiteFooter from '../components/SiteFooter'
import TopNav from '../components/TopNav'
import { articles } from '../data/articles'
import { buildCollectionSchema, buildOrganizationSchema, getAbsoluteUrl } from '../lib/seo'
import './ArticlesPage.css'

export default function ArticlesPage() {
  return (
    <div className="blog-page">
      <PageSeo
        title="Contrast Shower Articles | Recovery, Routines and Practical Guides"
        description="Practical articles on contrast showers, recovery, ice bath alternatives, and how to build a routine that actually sticks."
        canonical={getAbsoluteUrl('/articles')}
        image={getAbsoluteUrl('/images/blog-placeholder-basics.svg')}
        keywords={['contrast shower articles', 'contrast shower blog', 'contrast shower guides']}
        schema={[buildOrganizationSchema(), buildCollectionSchema()]}
      />

      <TopNav />

      <main>
        <PageHero innerClassName="blog-hero__inner">
            <div className="blog-hero__copy">
              <p className="eyebrow eyebrow--blog">Contrast Shower Journal</p>
              <h1 className="blog-hero__title heading-light">Straight-up guides for people who want the benefits without the carry-on.</h1>
              <p className="blog-hero__body p-intro">
                This is the article hub for contrast shower basics, recovery questions, ice bath comparisons,
                and the practical stuff people actually search for when they are trying to get started.
              </p>
            </div>

            <div className="blog-hero__note">
              <span className="blog-hero__label">Good place to start</span>
              <Link to="/articles/how-to-have-a-contrast-shower" className="blog-hero__featured-link">
                How to Have a Contrast Shower
              </Link>
              <p>
                Beginner-friendly, no fluff, and easy to fold into a normal week without pretending you live in a wellness lab.
              </p>
            </div>
        </PageHero>

        <section className="blog-grid-section">
          <div className="container">
            <div className="blog-grid">
              {articles.map((article) => (
                <article key={article.slug} className="blog-card">
                  <Link to={`/articles/${article.slug}`} className="blog-card__image-link">
                    <img src={article.image.src} alt={article.image.alt} className="blog-card__image" />
                  </Link>
                  <div className="blog-card__body">
                    <p className="blog-card__meta">
                      <span>{article.category}</span>
                      <span>{article.readingTime}</span>
                    </p>
                    <h2 className="blog-card__title">
                      <Link to={`/articles/${article.slug}`}>{article.title}</Link>
                    </h2>
                    <p className="blog-card__description">{article.description}</p>
                    <Link to={`/articles/${article.slug}`} className="blog-card__cta">
                      Read article
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  )
}
